import Role from '@/feature/ucenter/user/model/Role'

export default class WebSessionUser {
  id?: number
  name?: string
  loginName?: string
  companyId?: number
  token?: string
  platform?: string
  roles?: Array<Role>
  cartCount?: number
}